import { FormattedMessage, useIntl } from "react-intl";
import { Select } from "@/components/design/Select";

/** "" heißt: keine ausdrückliche Wahl, es gilt die Standardsprache der Plattform. */
export type MailLanguageChoice = "" | "DE" | "EN";

// Die Sprache der E-Mails zu dieser einen Bewerbung, ausdrücklich gewählt oder gar nicht. Bewusst ohne Vorbelegung:
// die Sprache der Oberfläche ist keine Wahl der Person, und ohne Wahl schreibt genesis in der Sprache, die die
// Administration für die Plattform eingestellt hat (@external-adr GENESIS-0097-a-mail-is-written-in-the-language-resolved-for-its-recipient).
export function MailLanguageField({
  id,
  value,
  disabled,
  onChange,
}: {
  id: string;
  value: MailLanguageChoice;
  disabled: boolean;
  onChange: (next: MailLanguageChoice) => void;
}) {
  const intl = useIntl();
  return (
    <label className="block">
      <span className="smycles-field-label">
        <FormattedMessage id="share.applications.mailLanguage.label" defaultMessage="Sprache der E-Mails zu dieser Bewerbung" />
      </span>
      <Select
        id={id}
        className="mt-1"
        value={value}
        disabled={disabled}
        hideEmpty
        options={[
          {
            value: "",
            label: intl.formatMessage({
              id: "share.applications.mailLanguage.default",
              defaultMessage: "Standardsprache der Plattform",
            }),
          },
          { value: "DE", label: intl.formatMessage({ id: "share.applications.mailLanguage.de", defaultMessage: "Deutsch" }) },
          { value: "EN", label: intl.formatMessage({ id: "share.applications.mailLanguage.en", defaultMessage: "English" }) },
        ]}
        onChange={(next) => onChange(next as MailLanguageChoice)}
      />
    </label>
  );
}
